import React from 'react';
import {
  WORDMARK_D,
  SUBLINE_D,
  WORDMARK_WIDTH,
  VB_HEIGHT,
  SUBLINE_OFFSET_X,
} from './logoPaths';

/**
 * Horrenmaker.nl wordmark — pure-vector SVG.
 *
 * Glyphs are baked SVG <path> data extracted from the Bowlby One typeface
 * (SIL OFL). No webfont is loaded at runtime — the mark renders identically
 * across all browsers and devices.
 *
 * Props:
 *   size:          rendered height in px of the main word (default 22)
 *   showTagline:   render the "by fliro.tech B.V." sub-line (default true)
 *   primary:       main word colour (default saffron orange)
 *   taglineColor:  sub-line colour (default muted grey)
 *   className:     pass-through className
 *   testId:        data-testid attribute
 */
export function Wordmark({
  size = 22,
  showTagline = true,
  primary = '#F26B1A',
  taglineColor = '#8A8A8A',
  className = '',
  testId,
}) {
  // The native font cap-height is 1570 units. We size the rendered SVG
  // so that `size` px equals the cap-height of the main word.
  const CAP_H = 1570;
  // ViewBox: full content area including sub-line + descenders.
  // Without sub line, crop just past the wordmark baseline.
  const vbH = showTagline ? VB_HEIGHT : CAP_H + 60;
  const renderH = (vbH / CAP_H) * size;
  const renderW = (WORDMARK_WIDTH / CAP_H) * size;

  return (
    <svg
      data-testid={testId}
      className={className}
      role="img"
      aria-label="Horrenmaker.nl by fliro.tech B.V."
      width={renderW}
      height={renderH}
      viewBox={`0 0 ${WORDMARK_WIDTH} ${vbH}`}
      preserveAspectRatio="xMinYMid meet"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d={WORDMARK_D} fill={primary} />
      {showTagline && (
        <g transform={`translate(${SUBLINE_OFFSET_X}, 0)`}>
          <path d={SUBLINE_D} fill={taglineColor} />
        </g>
      )}
    </svg>
  );
}
